module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"DeliveryDate":{"delivery":"{date} u vás","immediate":"dnes","pickUp":"{date} na pobočce","today":"dnes","tomorrow":"zítra"}}}')
  delete Component.options._Ctor
}
